<template>
  <div class="tag" v-if="size=='small'">
    <img src="https://cdn09.ehaier.com/shunguang/H5/www/img/sgmobile/search/living.gif" alt=""> 直播中
  </div>
  <div v-else class="tag-big">
    <img src="https://cdn09.ehaier.com/shunguang/H5/www/img/sgmobile/search/live_big.gif" alt="">
  </div>
</template>

<script>
export default {
  name: 'LiveTag',
  props: ['size']
}
</script>

<style lang="scss" scoped>
.tag{
  padding: 0 .12rem;
  height: .32rem;
  display: flex;
  justify-content: center;
  align-items: center;
  background: linear-gradient(90deg,#fa4f77, #ed2856 96%);
  border-radius: .06rem .22rem .22rem .22rem;
  font-size: .22rem;
  color: #fff;
  img{
    width: .25rem;
    transform: translateZ(0);
    will-change: auto;
  }
}

.tag-big{
  img{
    width: 1rem;
    transform: translateZ(0);
    will-change: auto;
  }
}
</style>
